import { EMPTY_CONDITION } from './emptyCondition';

export const EMPTY_GROUP = {
  conditions: [EMPTY_CONDITION],
  logicalOperator: 'and',
};
